import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'base64Image'
})
export class Base64ImagePipe implements PipeTransform {
  async transform(imageUrl: string): Promise<string> {
    try {
      return await this.getImageBase64(imageUrl);
    } catch (error) {
      console.error('Error transforming image:', error);
      throw error;
    }
  }

  private async getImageBase64(url: string): Promise<string> {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result as string);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error('Error fetching image:', error);
      throw error;
    }
  }
}
